import React, { Component } from 'react'
import { AppContext, AccountFeatures } from '@lightspeed-invoicing/core-client/frontend'
import { FormattedMessage, injectIntl, defineMessages } from 'react-intl'
import ContentTypes from "../content/ContentTypes.jsx"
import ButtonWrapper from '../../../common/rich-text/feature-protection-wrappers/buttonProtectionWrapper.component'

class TemplateSectionEditForm extends Component {

    constructor(props, context) {
        super(props, context);

        this.state = {
            id: '',
            documentId: '',
            sectionsOrder: [],
            rank: 0,
            contentType: this.props.contentType || 'title',
            currentRank: this.props.currentRank === undefined ? '' : this.props.currentRank,
            content: {},
            variables: this.props.variables || null,
            internalName: '',
            deleteButton: '',
            containerFormClassName: this.props.containerFormClassName || '',
            className: this.props.className || 'row ui-has-modules',
            contentTypeClassName: this.props.contentTypeClassName || 'col-12',
            formClassName: this.props.formClassName || 'col-12 ui-module',
            buttonClassName: this.props.buttonClassName || 'col-12 ui-module text-right',
            onChange: this.props.onChange || function () { },
            onClose: this.props.onClose || function () { },
        }

        this.submit = this.submit.bind(this)
        this.handleFormChange = this.handleFormChange.bind(this)
        this.remove = this.remove.bind(this)
        this.close = this.close.bind(this)
        this.handleContentTypeChange = this.handleContentTypeChange.bind(this)
        this.handleContentChange = this.handleContentChange.bind(this)
    }

    componentDidMount() {
        const section = this.props.value
        const documentId = this.props.documentId
        if (section && section.id) {
            const contentType = section.attributes.contentType
            const deleteButton =
                <ButtonWrapper
                    isProtected={contentType === 'payment'}
                    onClick={this.remove}
                    redirectToAccount={true}
                    accountFeatureKey={AccountFeatures.FeatureRemovePaymentButton}
                    className={'btn btn-danger'}>
                    <span>
                        <FormattedMessage
                            id="templates.sections.form.edit.delete_btn"
                            defaultMessage="Delete section"
                        />
                    </span>
                </ButtonWrapper>
            this.setState({
                id: section.id,
                documentId: section.attributes.documentId,
                internalName: section.attributes.internalName,
                contentType: section.attributes.contentType,
                content: section.attributes.content,
                deleteButton: deleteButton,
            })
        } else {
            AppContext.getApiClient().get('/documents/' + documentId + '/sections').then(r => {
                this.setState({
                    rank: r.data.length,
                    documentId: documentId,
                    sectionsOrder: r.data.map(s => s.id),
                })
            })
        }
    }

    remove(event) {
        AppContext.getApiClient().delete('/documents/' + this.state.documentId + '/sections/' + this.state.id).then((response) => {
            if (!response.error) {
                this.state.onChange(response)
            }
        })
        event.preventDefault()
    }

    save() {
        const doc = this.props.value
        if (doc && doc.id) {
            let updates = {}
            const allowedFields = [
                "internalName",
                "content",
            ]
            for (let i = 0; i < allowedFields.length; i++) {
                let field = allowedFields[i]
                if (doc.attributes[field] != this.state[field]) {
                    updates[field] = this.state[field]
                }
            }
            return AppContext.getApiClient().patch('/documents/' + this.state.documentId + '/sections/' + this.state.id, updates)
        } else {
            return AppContext.getApiClient().post('/documents/' + this.state.documentId + '/sections', {
                "internalName": this.state.internalName,
                "documentId": this.state.documentId,
                "content": this.state.content,
                "rank": this.state.rank,
                "contentType": this.state.contentType,
            })
        }
    }

    submit(event) {
        event.preventDefault()
        this.save().then(res => {
            if (!res.error) {
                const section = this.props.value
                if (!section && this.state.currentRank !== '') {
                    const newOrder = []
                    for (let index in this.state.sectionsOrder) {
                        newOrder.push(this.state.sectionsOrder[index])
                        if (index == this.state.currentRank) {
                            newOrder.push(res.id)
                        }
                    }
                    AppContext.getApiClient().patch('/documents/' + this.state.documentId, {
                        sectionsOrder: newOrder,
                    }).then(r => {
                        this.state.onChange(res)
                    })
                } else {
                    this.state.onChange(res)
                }
            }
        })
    }

    close(event) {
        event.preventDefault()
        this.state.onClose()
    }

    handleFormChange(event) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;

        this.setState({
            [name]: value
        })
    }

    handleContentTypeChange(contentType) {
        this.setState({
            contentType: contentType
        })
    }

    handleContentChange(content) {
        this.setState({
            content: content
        })
    }

    render() {
        const contentType = ContentTypes.getById(this.state.contentType)
        let internalName = ''
        const form = ContentTypes.getInputComponent(this.state.contentType, this.state.content, this.state.variables, this.handleContentChange)
        let box = <div className={this.state.formClassName}>
            {internalName}
            {form}
        </div>
        if (form === '' && internalName === '') {
            box = ''
        } else if (this.state.containerFormClassName) {
            box = <div className={this.state.containerFormClassName}>
                {box}
            </div>
        }

        return (
            <form onSubmit={this.submit}>
                {this.state.formStatus}
                <div className={this.state.className}>
                    <div className={this.state.contentTypeClassName}>
                        <div className="form-group row">
                            <div className="col-6">
                                <h5>
                                    <p>{contentType.icon} {contentType.name}</p>
                                    <p><small className="mt-1">{contentType.description}</small></p>
                                </h5>
                            </div>
                        </div>
                    </div>
                    {box}
                    <div className={this.state.buttonClassName}>
                        {!contentType.mandatory ?
                            this.state.deleteButton
                            : ''}
                        &nbsp;
                        &nbsp;
                        <a href={'#'} className="btn btn-light" onClick={this.close}>
                            <FormattedMessage
                                id="templates.sections.form.edit.cancel_btn"
                                defaultMessage="Cancel"
                            />
                        </a>
                        &nbsp;
                        &nbsp;
                        <button type="submit" className="btn btn-primary">
                            <FormattedMessage
                                id="templates.sections.form.edit.save_btn"
                                defaultMessage="Save"
                            />
                        </button>
                    </div>
                </div>
            </form>
        );
    }
}

export default injectIntl(TemplateSectionEditForm)


// WEBPACK FOOTER //
// ./src/template/sections/form/edit.component.jsx